// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2qIWP","col":"Table_col__6jCjx","fulfillmentStatus":"Table_fulfillmentStatus__2vjT-","emailCol":"Table_emailCol__1siGv"};